import React, { useEffect, useRef, useState } from "react"
import ClassNames from "classnames"
import { get } from "lodash"

type List = {
  id: number | string
  name: string
}

type Props = {
  list: Array<List>
  active: number | string
  onChange: Function
  className?: string
}

export const Tab = (props: Props) => {
  return (
    <ul className={props.className}>
      {props.list.map((row, i) => (
        <li
          key={i}
          className={ClassNames("btn-tab", {
            active: row.id === props.active,
          })}
          onClick={() => {
            props.onChange(row.id)
          }}
        >
          {row.name}
        </li>
      ))}
    </ul>
  )
}

export const MoveSpTab = (
  props: Props & { container: HTMLElement; active: number }
) => {
  const tabItem = useRef<HTMLLIElement>(null)
  const [position, setPosition] = useState<number>(0)
  const [movingVolume, setMovingVolume] = useState<number>(0)
  const [firstPosition, setFirstPosition] = useState<number>(null)

  const containerWidth = get(props.container, "offsetWidth")
  const tabItemWidth = get(tabItem.current, "offsetWidth")
  const allItemWidth = tabItemWidth * props.list.length

  const maxMovingVolume = containerWidth - allItemWidth

  const judgeMoveVolume = (move: number) =>
    move > 0 ? 0 : move < maxMovingVolume ? maxMovingVolume : move

  const stopMove = () => {
    const move = position + movingVolume
    setPosition(judgeMoveVolume(move))
    setMovingVolume(0)
    setFirstPosition(null)
  }

  useEffect(() => {
    setPosition(
      (props.active + 1) * -tabItemWidth +
        (containerWidth / 2 + tabItemWidth / 2)
    )
  }, [props.active])

  return (
    <div
      style={{
        position: "relative",
        height: get(tabItem.current, "offsetHeight"),
        marginBottom: "0.8rem",
      }}
      onTouchStart={e => setFirstPosition(e.touches[0].pageX)}
      onTouchEnd={() => stopMove()}
      onTouchCancel={() => stopMove()}
      onTouchMove={e =>
        firstPosition !== null &&
        setMovingVolume(e.touches[0].pageX - firstPosition)
      }
    >
      <ul
        className={props.className}
        style={{
          position: "absolute",
          left: judgeMoveVolume(position + movingVolume),
        }}
      >
        {props.list.map((row, i) => (
          <li
            key={i}
            ref={elm => (!i ? (tabItem.current = elm) : null)}
            className={ClassNames("btn-tab", {
              active: row.id === props.active,
            })}
            onClick={() => {
              props.onChange(row.id)
            }}
          >
            {row.name}
          </li>
        ))}
      </ul>
    </div>
  )
}
